function getAlertHtml (message) {
  const html = []
  html.push('<div class="alert alert-danger alert-dismissible">')
  html.push('<button type="button" class="close" data-dismiss="alert">')
  html.push('<span>&times;</span>')
  html.push(`</button>${message}`)
  html.push('</div>')
  return html.join('')
}

export default getAlertHtml
